<template>
  <b-modal
    :active="visible"
    has-modal-card
    @close="$emit('cancel')"
    :custom-class="'conflict-dialog-modal'"
  >
    <div
      class="modal-card"
      style="width: auto; min-width: 450px; max-width: 960px"
    >
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t('conflict.title') }}</p>
        <button
          class="delete"
          :aria-label="$t('close')"
          @click="$emit('cancel')"
        ></button>
      </header>

      <section class="modal-card-body">
        <ConflictItem
          v-for="(entity, index) in conflicts"
          :key="entity.localEntity._id"
          :entity="entity"
          :index="index"
          :resolution="resolution"
          :customFieldComponents="customFieldComponents"
          :fieldsWithoutDisplay="fieldsWithoutDisplay"
          :module="module"
          :mode="entity.mode"
          @resolve-field="resolveField"
          @resolve-all="resolveAll"
        />
      </section>

      <footer class="modal-card-foot is-justify-content-flex-end">
        <b-button type="is-light" @click="$emit('cancel')">{{
          $t('conflict.cancel')
        }}</b-button>
        <b-button
          type="is-primary"
          :disabled="!isAllResolved"
          @click="confirmResolution"
        >
          {{ $t('conflict.confirm') }}
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import ConflictItem from './components/conflict/ConflictItem';
import {
  LINKED_FIELDS,
  FIELDS_WITHOUT_DISPLAY,
  CUSTOM_FIELD_COMPONENTS,
} from './constants/conflict-constants';

import { buildResolutionResults } from './utils/conflict-utils';

export default {
  name: 'ConflictDialog',
  components: {
    ConflictItem,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    conflicts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      resolution: {},
      customFieldComponents: CUSTOM_FIELD_COMPONENTS,
      linkedFields: LINKED_FIELDS,
      fieldsWithoutDisplay: FIELDS_WITHOUT_DISPLAY,
    };
  },
  computed: {
    isAllResolved() {
      return this.conflicts.every((conflict, index) => {
        const changed = Object.keys(conflict.differences);
        return changed.every((key) => this.resolution[index]?.[key]);
      });
    },
    module() {
      const module = this.$route.path.split('/')[2];
      return module || 'publisher';
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.resetResolution();
      }
    },
  },
  methods: {
    resetResolution() {
      this.resolution = {};
    },
    buildResolutionResults,
    resolveField(index, key, version) {
      if (!this.resolution[index]) this.$set(this.resolution, index, {});
      this.$set(this.resolution[index], key, version);

      const linked = this.linkedFields[key];
      if (linked) {
        linked.forEach((linkedKey) => {
          this.$set(this.resolution[index], linkedKey, version);
        });
      }
    },
    resolveAll(index, version) {
      const fields = this.conflicts[index].differences;
      if (!this.resolution[index]) this.$set(this.resolution, index, {});
      Object.keys(fields).forEach((key) => {
        if (key !== 'version') {
          this.$set(this.resolution[index], key, version);
        }
      });
    },
    confirmResolution() {
      const results = this.buildResolutionResults(
        this.conflicts,
        this.resolution
      );
      this.$emit('resolved', results);
    },
  },
};
</script>

<style scoped>
.conflict-dialog-modal {
  z-index: 9999 !important;
}
</style>
